var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7632 9.33335C14.7632 8.96669 14.4528 8.66669 14.0734 8.66669H12.6938V10H14.0734C14.4528 10 14.7632 9.70002 14.7632 9.33335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0734 11.3334H12.6938V12.6667H14.0734C14.4528 12.6667 14.7632 12.3667 14.7632 12C14.7632 11.6334 14.4528 11.3334 14.0734 11.3334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55536 9.33333H7.17578V12H8.55536C8.55536 12.7333 9.17617 13.3333 9.93493 13.3333H12.0043V8H9.93493C9.17617 8 8.55536 8.6 8.55536 9.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72674 8.66669C3.72674 7.93335 4.34755 7.33335 5.10632 7.33335H6.141C7.47229 7.33335 8.55526 6.28669 8.55526 5.00002C8.55526 3.71335 7.47229 2.66669 6.141 2.66669H3.72674C3.34736 2.66669 3.03696 2.96669 3.03696 3.33335C3.03696 3.70002 3.34736 4.00002 3.72674 4.00002H6.141C6.71353 4.00002 7.17568 4.44669 7.17568 5.00002C7.17568 5.55335 6.71353 6.00002 6.141 6.00002H5.10632C3.58189 6.00002 2.34717 7.19335 2.34717 8.66669C2.34717 10.14 3.58189 11.3334 5.10632 11.3334H6.4859V10H5.10632C4.34755 10 3.72674 9.40002 3.72674 8.66669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5549,
    height: 16,
    fill: "white",
    transform: "translate(0.277832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalIcon);
export default __webpack_public_path__ + "static/media/electrical-icon.53ba5ec6415bc1b57e9c7b1a93291936.svg";
export { ForwardRef as ReactComponent };